import React from 'react';
import { useTranslation } from 'react-i18next';
import { URLS } from '@wix/da-url';
import ChatButtonAndDropdown from '../ChatButtonAndDropdown';
import { useVerification } from '../../../VerificationPopup/withVerification';
import BiButton from '@wix/da-bi/pkg/Components/BiButton';
import { BiData } from '@wix/da-bi/pkg/events';
import { IconSize } from '@wix/da-ds/pkg/Icons/IconWrap';
import ChatIcon from '@wix/da-ds/pkg/Icons/24x24/Comment';
import { limitNumber } from '../../helpers';
var ChatLink = function (_a) {
    var chatCount = _a.chatCount, noteCount = _a.noteCount, isLegacyHeader = _a.isLegacyHeader, disableFloatingChat = _a.disableFloatingChat, className = _a.className, iconClassName = _a.iconClassName, numberClassName = _a.numberClassName;
    var _b = useVerification(), isVerificationNeeded = _b.isVerificationNeeded, pushVerificationPopup = _b.pushVerificationPopup;
    var t = useTranslation().t;
    if (isVerificationNeeded) {
        return (React.createElement(BiButton, { biData: BiData({
                evid: 700,
                link_url: URLS.CHAT_HOME,
                link_name: 'chat',
                indicator: chatCount,
            }), className: className, onClick: function () { return pushVerificationPopup('chat'); }, "aria-label": t('siteHeader.a11y.openAccountVerificationDialog') },
            React.createElement(ChatIcon, { size: IconSize.MEDIUM, className: iconClassName, disableDefaultColors: true })));
    }
    return (React.createElement(ChatButtonAndDropdown, { disableDropdown: isLegacyHeader, disableFloatingChat: disableFloatingChat, indicator: (chatCount > 0 || noteCount > 0) && (React.createElement("span", { className: numberClassName }, limitNumber((chatCount || 0) + (noteCount || 0)))) }));
};
ChatLink.displayName = 'ChatLink';
export default ChatLink;
//# sourceMappingURL=ChatLink.js.map